<template>
  <div class="d-flex flex-column overflow-hidden">
    <v-text-field
      v-model="search"
      variant="underlined"
      prepend-inner-icon="mdi-magnify"
      hide-details
      label="Search"
      class="ma-2"
      data-cy="stage-search-input"
    ></v-text-field>
    <div class="overflow-y-auto">
      <div v-if="recommendedStages.length && !search" data-cy="recommended-stages-section">
        <div class="text-overline" data-cy="recommended-stages-title">Recommended Stages</div>
        <button
          v-for="stage in recommendedStages"
          :key="stage.id"
          class="stageButton"
          :data-cy="`recommended-stage-button-${stage.id}`"
          @click="$emit('select', stage)"
        >
          {{ stage.name }}
        </button>
        <v-divider data-cy="stage-list-divider"></v-divider>
      </div>
      <div data-cy="filtered-stage-list">
        <button
          v-for="stage in filtered"
          :key="stage.id"
          class="stageButton"
          :data-cy="`stage-button-${stage.id}`"
          @click="$emit('select', stage)"
        >
          {{ stage.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useEventStore } from '../stores/event'

export default {
  emits: ['select'],
  setup() {
    let eventStore = useEventStore()
    return { eventStore }
  },
  data() {
    return {
      search: '',
      stages: [],
      recommended: {
        1: [19, 11, 25, 20, 22, 15], //Smash Melee
        1386: [311, 484, 378, 397, 387, 328, 348, 513, 407, 353] //Smash Ultimate
      }
    }
  },
  computed: {
    currentGameId() {
      return this.eventStore.game?.id
    },
    filtered() {
      const searchTerm = (this.search || '').toLowerCase()
      if (!Array.isArray(this.stages)) return []
      return this.stages.filter((stage) =>
        stage.name
          .normalize('NFD')
          .replace(/[^a-z]/gi, '')
          .toLowerCase()
          .includes(searchTerm)
      )
    },
    recommendedStages() {
      let result = []
      if (!Array.isArray(this.stages) || !this.currentGameId) return []

      const recommendedIds = this.recommended[this.currentGameId]
      if (recommendedIds) {
        const recommendedIdSet = new Set(recommendedIds)
        result = this.stages.filter((stage) => recommendedIdSet.has(stage.id))
      }
      return result
    }
  },
  mounted() {
    this.stages = this.eventStore.game?.stages || []
  }
}
</script>

<style>
.stageButton {
  width: 100%;
  border-radius: 4px;
}

.stageButton:hover {
  background-color: rgba(211, 211, 211, 0.2);
}
</style>
